'use es6';

import { List } from 'immutable';
import http from 'hub-http/clients/apiClient';
import { formatCommentCounts } from 'reference-resolvers/formatters/formatComments';
const BASE_URL = 'commenting/v1/commenting/batch';
export const createGetBatchCommentCountsById = ({
  httpClient
}) => ids => {
  // ids must be an array of `<assetId>&<crmObjectType>`
  if (!Array.isArray(ids) || ids.length === 0 || !ids.every(id => id.split('&').length === 2)) {
    return Promise.resolve(List([]));
  }
  const objectType = ids[0].split('&')[1];
  const objectIds = ids.map(id => id.split('&')[0]);
  console.log('returning client post');
  return httpClient.post(`${BASE_URL}/${objectType}`, {
    data: {
      objectIds
    },
    query: {
      limit: 0
    }
  }).then(res => formatCommentCounts(res, objectType));
};
export const getBatchCommentCountsById = createGetBatchCommentCountsById({
  httpClient: http
});